import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const PointsEconomyControls = () => {
  const [pointsRates, setPointsRates] = useState([
    { activity: 'Check-in', points: 10, multiplier: 1.0 },
    { activity: 'Workout Completion', points: 25, multiplier: 1.0 },
    { activity: 'Class Attendance', points: 30, multiplier: 1.0 },
    { activity: 'Referral (Successful)', points: 100, multiplier: 1.0 },
    { activity: 'Social Post', points: 5, multiplier: 1.0 },
    { activity: 'Review/Feedback', points: 15, multiplier: 1.0 }
  ]);

  const [seasonalMultiplier, setSeasonalMultiplier] = useState(1.5);
  const [specialEventActive, setSpecialEventActive] = useState(false);

  return (
    <div className="space-y-6">
      <div className="card">
        <div className="mb-6">
          <h2 className="text-xl font-heading font-semibold text-foreground mb-1">
            Points Economy Controls
          </h2>
          <p className="text-sm text-muted-foreground">
            Adjust point earning rates and multipliers for different activities
          </p>
        </div>

        <div className="space-y-3">
          {pointsRates?.map((rate, index) => (
            <div
              key={index}
              className="p-4 rounded-lg border border-border hover:bg-muted/30 transition-colors"
            >
              <div className="flex items-center justify-between gap-4">
                <div className="flex-1">
                  <h3 className="font-medium text-foreground mb-1">{rate?.activity}</h3>
                  <div className="flex items-center gap-2">
                    <Icon name="Coins" size={14} color="var(--color-primary)" />
                    <span className="text-sm text-primary font-semibold">
                      {rate?.points} points
                    </span>
                    {rate?.multiplier > 1 && (
                      <span className="px-2 py-0.5 rounded-full bg-accent/20 text-accent text-xs font-medium">
                        {rate?.multiplier}x multiplier
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Input
                    type="number"
                    defaultValue={rate?.points}
                    className="w-20"
                  />
                  <Button variant="outline" size="sm" iconName="Save">
                    Save
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Seasonal & Event Multipliers */}
      <div className="card">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
          Seasonal & Event Multipliers
        </h2>
        <div className="space-y-4">
          <div className="p-4 rounded-lg border-2 border-accent/30 bg-accent/5">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent/20 flex items-center justify-center">
                  <Icon name="Sparkles" size={20} color="var(--color-accent)" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground">Seasonal Bonus</h3>
                  <p className="text-sm text-muted-foreground">Active until end of month</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-2xl font-heading font-bold text-accent">{seasonalMultiplier}x</p>
                <p className="text-xs text-muted-foreground">multiplier</p>
              </div>
            </div>
            <div className="flex gap-2">
              <Input
                type="number"
                step="0.1"
                defaultValue={seasonalMultiplier}
                className="flex-1"
              />
              <Button variant="default" size="sm">
                Update
              </Button>
            </div>
          </div>

          <div className="p-4 rounded-lg border border-border">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-warning/20 flex items-center justify-center">
                  <Icon name="Zap" size={20} color="var(--color-warning)" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground">Special Event Mode</h3>
                  <p className="text-sm text-muted-foreground">Double points for all activities</p>
                </div>
              </div>
              <Button
                variant={specialEventActive ? 'success' : 'outline'}
                onClick={() => setSpecialEventActive(!specialEventActive)}
              >
                {specialEventActive ? 'Active' : 'Activate'}
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Impact Analysis */}
      <div className="card bg-gradient-to-r from-primary/10 to-accent/10 border-2 border-primary/20">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
          Real-Time Impact Analysis
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Projected Points Issued</p>
            <p className="text-2xl font-heading font-bold text-foreground">+24.5K</p>
            <p className="text-xs text-success">+12% vs last month</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">Member Engagement</p>
            <p className="text-2xl font-heading font-bold text-foreground">+8.3%</p>
            <p className="text-xs text-success">Predicted increase</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">Redemption Rate</p>
            <p className="text-2xl font-heading font-bold text-foreground">18.7%</p>
            <p className="text-xs text-muted-foreground">Expected rate</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PointsEconomyControls;